import { CalcRowCostAccountingController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Shows the cost accounting details for the calculation row.
 * @example
 * ```html
 * <salaxy-calc-row-cost-accounting parent="$ctrl.parent" current="$ctrl.current"></salaxy-calc-row-cost-accounting>
 * ```
 */
export class CalcRowCostAccounting extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Calculation for the row. */
      calc: "<",
      /** The calculation row. */
      row: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
       dimensions: "<",
    };

    /** Uses the CalcRowCostAccountingController */
    public controller = CalcRowCostAccountingController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/rows/CalcRowCostAccounting.html";
}
